import * as React from 'react'
import Grid from '@material-ui/core/Grid'
import { Item, NewButton, Select, alphabeticalSort } from 'prace-common-components'
import { ChangePartitionModalProps } from './types'
import { $ModalContainer, $Grid, $Container } from './styles'

export const ChangePartitionModal: React.FC<ChangePartitionModalProps> = 
({ activeCutOff, initialPartition, loading, handlePartition, handleCancel }) => {
  const defaultPartition = initialPartition ? String(initialPartition.id) : null
  const [partitionId, setPartitionId] = React.useState<Nullable<string>>(defaultPartition)

  const resources = activeCutOff?.resources ? activeCutOff.resources : []
  /* Remove resources that are not from the active cutoff and selected partition */
  const allowedResourcePartitions = resources.filter((resource) => !resource.partition.disabled)
  const partitionOptions: Item[] =  [...new Set(allowedResourcePartitions.map((resource) => ({
    label: resource.partition.name, value: resource.partition.id,
  } as Item)))] || []
  
  /* Sort partitions by name */
  const sortedPartitionOptions = alphabeticalSort(partitionOptions, 'label')

  return (
    <$ModalContainer>
      <>
        <$Grid container>
          <Grid item xs={12}>
            <Select
              title='Select Partition'
              name='partitionId'
              value={partitionId}
              items={sortedPartitionOptions}
              onChange={(_name: string, value: Nullable<string>) => setPartitionId(value)}
            />
          </Grid>
        </$Grid>
        <$Container container justifyContent='space-between'>
          <Grid item xs={3}>
            <NewButton loading={loading} onClick={() => handlePartition(partitionId)}>Change</NewButton>
          </Grid>
          <Grid item xs container justifyContent='flex-end'>
            <NewButton variant='outlined' onClick={handleCancel}>Cancel</NewButton>
          </Grid>
        </$Container>
      </>
    </$ModalContainer>
  )
}
